import { useAuth0 } from '@auth0/auth0-react'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { CenteredScreen } from '@/components/layout/centered-screen'

function SignOutPage() {
  const { logout } = useAuth0()

  useEffect(() => {
    void logout({ logoutParams: { returnTo: `${window.location.origin}/sign_in` } })
  }, [logout])

  return <CenteredScreen aria-label="ログアウト中" />
}

export const Route = createFileRoute('/sign_out')({ component: SignOutPage })
